import type { CSSProperties } from 'react';

export type StyleOverride =
  | CSSProperties
  | false
  | null
  | undefined
  | readonly StyleOverride[];

export const resolveStyleOverride = (
  styleOverride?: StyleOverride,
): CSSProperties | undefined => {
  if (!styleOverride) return undefined;

  if (Array.isArray(styleOverride)) {
    return styleOverride.reduce<CSSProperties>((acc, part) => {
      const resolvedPart = resolveStyleOverride(part);
      return resolvedPart ? { ...acc, ...resolvedPart } : acc;
    }, {});
  }

  return styleOverride as CSSProperties;
};
